<script lang="ts">
	import { crossfade, fly } from 'svelte/transition';
	import { store } from './store';
	import { flip } from 'svelte/animate';

	let notifications = store.displayNotification;
	let notifStore = store.notifications;

	const [send, receive] = crossfade({
		duration: 300
	});

	function removeNotification(id: string) {
		return function () {
			$notifStore = [
				...$notifStore.map((n) => {
					if (n.id !== id) return n;
					return {
						...n,
						isExpired: true
					};
				})
			];
		};
	}
</script>

<div class="fixed bottom-4 right-4 z-50">
	{#each $notifications as notification (notification.id)}
		<div
			class="mb-2 rounded-lg bg-grey-900 px-3 py-2 text-white"
			animate:flip
			in:fly={{ y: 20 }}
			out:send={{ key: notification.id }}
		>
			<div class="flex items-center gap-2">
				<div class="flex items-start gap-2">
					{#if notification.icon}
						<div translate="no" class="material-icons-round mt-1 text-base text-white">
							{notification.icon}
						</div>
					{/if}
					<div>
						<div class="text-md text-white">
							{notification.title}
						</div>
						{#if notification.subtitle}
							<div class="mt-1 text-sm text-grey-800">{notification.subtitle}</div>
						{/if}
					</div>
				</div>
				{#if notification.actionCTA && notification.action}
					<button
						class="rounded-lg bg-grey-900 px-2 py-1 text-sm font-medium text-violet-300 hover:bg-grey-800 active:bg-grey-700"
						on:click={notification.action}>{notification.actionCTA}</button
					>
				{/if}
				<button
					translate="no"
					class="material-icons-round text-md bg-grey-900 font-medium text-grey-700 hover:text-grey-800 active:text-grey-600"
					on:click={removeNotification(notification.id)}
				>
					close
				</button>
			</div>
		</div>
	{/each}
</div>
<div class="visible fixed bottom-4 right-[-40px] z-50 opacity-[0.5]">
	{#each $notifStore.filter((n) => n.isExpired) as n (n.id)}
		<div in:receive={{ key: n.id }} class="mb-2 h-10 w-1" />
	{/each}
</div>
